import { AuthenticateRequest } from '../../Interfaces/AuthenticationRequest';
import { actionCreators } from './UserSessionState';
import { actionCreators as alertActionCreators } from '../Alerts/AlertsState';
import { actionCreators as assetActionCreators } from '../Assets/AssetsState';
import { getMsalInstance } from '../../components/SSO/msalInstance';

export const onLogin = async (
  dispatch: any,
  credentials: AuthenticateRequest | undefined,
  idToken: string | undefined
) => {
  return dispatch(actionCreators.onLogin(credentials, idToken));
};

export const onLogout = async (dispatch: any) => {
  const msalInstance = getMsalInstance();
  if (msalInstance) {
    const logoutRequest = {
      account: msalInstance.getActiveAccount(),
      prompt: 'none',
    };

    msalInstance
      .logoutPopup(logoutRequest)
      .then(() => {
        dispatch(actionCreators.onLogout());
        dispatch(alertActionCreators.resetState());
        dispatch(assetActionCreators.resetState());
      })
      .catch(() => {});
  } else {
    dispatch(actionCreators.onLogout());
    dispatch(alertActionCreators.resetState());
    dispatch(assetActionCreators.resetState());
  }
};
